/* RAKAN theme core: nav, reveals, cart helpers, hero video. No external deps. */
(function () {
  'use strict';
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- mobile menu ---------- */
  const burger = document.getElementById('rkBurger');
  const overlay = document.getElementById('rkMenuOverlay');
  if (burger && overlay) {
    burger.addEventListener('click', () => {
      const open = overlay.classList.toggle('open');
      burger.setAttribute('aria-expanded', open);
    });
    overlay.querySelectorAll('a').forEach(a => a.addEventListener('click', () => {
      overlay.classList.remove('open');
      burger.setAttribute('aria-expanded', 'false');
    }));
  }

  /* ---------- scroll reveals ---------- */
  const reveals = document.querySelectorAll('.reveal');
  if (reduced || !('IntersectionObserver' in window)) {
    reveals.forEach(el => { el.style.opacity = 1; el.style.transform = 'none'; });
  } else {
    reveals.forEach(el => {
      el.style.transition = 'opacity .85s cubic-bezier(.32,.72,0,1), transform .85s cubic-bezier(.32,.72,0,1)';
      el.style.transitionDelay = (el.dataset.delay || 0) + 'ms';
    });
    const io = new IntersectionObserver(entries => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          e.target.style.opacity = 1;
          e.target.style.transform = 'none';
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -12% 0px' });
    reveals.forEach(el => io.observe(el));
  }

  /* content injected after load (recommendation rows) carries .reveal, which is
     opacity:0 by default and was never observed above; reveal it on demand */
  window.rkRevealIn = function (root) {
    root.querySelectorAll('.reveal').forEach((el, i) => {
      if (reduced) { el.style.opacity = 1; el.style.transform = 'none'; return; }
      el.style.transition = 'opacity .7s cubic-bezier(.32,.72,0,1), transform .7s cubic-bezier(.32,.72,0,1)';
      el.style.transitionDelay = (i * 70) + 'ms';
      requestAnimationFrame(() => { el.style.opacity = 1; el.style.transform = 'none'; });
    });
  };

  /* ---------- hero video: pause when curtain covers it ---------- */
  const heroVideo = document.getElementById('heroVideo');
  if (heroVideo) {
    if (reduced) { heroVideo.removeAttribute('autoplay'); heroVideo.pause(); }
    /* pause the curtain-covered video: a section "covers" the sticky hero while it
       occupies the top band of the viewport; track how many do */
    const coverEls = document.querySelectorAll('.sec, .footer');
    if (coverEls.length && 'IntersectionObserver' in window && !reduced) {
      const covering = new Set();
      const io = new IntersectionObserver(entries => {
        entries.forEach(e => { e.isIntersecting ? covering.add(e.target) : covering.delete(e.target); });
        if (covering.size > 0) heroVideo.pause();
        else heroVideo.play().catch(() => {});
      }, { rootMargin: '0px 0px -94% 0px', threshold: 0 });
      coverEls.forEach(el => io.observe(el));
    }
  }

  /* ---------- cart helpers ---------- */
  const toastEl = document.getElementById('rkToast');
  let toastTimer;
  window.rkToast = function (msg) {
    if (!toastEl) return;
    toastEl.querySelector('span').textContent = msg;
    toastEl.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toastEl.classList.remove('show'), 2600);
  };

  /* a preview/host page may pre-define these shims; respect them */
  window.rkUpdateCartCount = window.rkUpdateCartCount || function () {
    fetch('/cart.js').then(r => r.json()).then(cart => {
      document.querySelectorAll('[data-cart-count]').forEach(el => {
        el.textContent = cart.item_count;
        el.hidden = cart.item_count === 0;
      });
    }).catch(() => {});
  };

  window.rkAddToCart = window.rkAddToCart || function (payload, successMsg) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    }).then(r => {
      if (!r.ok) return r.json().then(e => Promise.reject(e));
      return r.json();
    }).then(res => {
      window.rkUpdateCartCount();
      if (window.rkShowUpsell) {
        window.rkShowUpsell(res, successMsg || 'اتضافت لعربيتك');
      } else {
        window.rkToast(successMsg || 'اتضافت لعربيتك');
      }
      return res;
    }).catch(err => {
      window.rkToast((err && err.description) || 'حصلت مشكلة، جرب تاني');
      return Promise.reject(err);
    });
  };

  /* ---------- post-add upsell panel ---------- */
  const upsellEl = document.getElementById('rkUpsell');
  let upsellTimer;
  let upsellSuppress = false; /* adds fired from inside the panel don't re-open it */

  function hideUpsell() {
    if (!upsellEl) return;
    clearTimeout(upsellTimer);
    upsellEl.classList.remove('show');
    setTimeout(() => { upsellEl.hidden = true; }, 450);
  }

  /* only same-origin paths and http(s) URLs may reach href/src */
  function safeUrl(u) {
    return (typeof u === 'string' && /^(\/(?!\/)|https?:\/\/|\/\/)/.test(u)) ? u : '';
  }

  /* built as DOM nodes, never as an HTML string: product titles and URLs come
     from the recommendations feed and must not be parsed as markup */
  function renderUpsellItem(p) {
    const row = document.createElement('div');
    row.className = 'rk-upsell-item';

    let img = safeUrl(p.featured_image || (p.images && p.images[0]) || '');
    if (img) { img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=120'; }
    if (img) {
      const im = document.createElement('img');
      im.src = img;
      im.alt = '';
      im.width = 56; im.height = 66;
      im.loading = 'lazy';
      row.appendChild(im);
    } else {
      const ph = document.createElement('span');
      ph.className = 'rk-upsell-noimg';
      ph.setAttribute('aria-hidden', 'true');
      row.appendChild(ph);
    }

    const info = document.createElement('div');
    info.className = 'rk-upsell-info';
    const link = document.createElement('a');
    link.href = safeUrl(p.url) || '/';
    link.textContent = p.title;
    info.appendChild(link);

    const price = document.createElement('span');
    price.className = 'rk-upsell-price';
    const now = document.createElement('strong');
    now.textContent = Math.round(p.price / 100) + ' جنيه';
    price.appendChild(now);
    if (p.compare_at_price && p.compare_at_price > p.price) {
      const was = document.createElement('s');
      was.textContent = Math.round(p.compare_at_price / 100);
      price.appendChild(document.createTextNode(' '));
      price.appendChild(was);
    }
    info.appendChild(price);
    row.appendChild(info);
    const oneVariant = p.variants && p.variants.length === 1 && p.variants[0].available;
    if (oneVariant) {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'rk-upsell-add';
      btn.textContent = 'ضيفه';
      btn.addEventListener('click', () => {
        upsellSuppress = true;
        btn.disabled = true;
        window.rkAddToCart({ items: [{ id: p.variants[0].id, quantity: 1 }] })
          .then(() => hideUpsell())
          .catch(() => { btn.disabled = false; })
          .finally(() => { upsellSuppress = false; });
      });
      row.appendChild(btn);
    } else {
      const go = document.createElement('a');
      go.className = 'rk-upsell-add rk-upsell-go';
      go.href = p.url;
      go.textContent = 'اختار';
      row.appendChild(go);
    }
    return row;
  }

  window.rkShowUpsell = function (res, successMsg) {
    window.rkToast(successMsg); /* instant feedback either way */
    if (!upsellEl || upsellSuppress) return;
    const added = res && res.items ? res.items[0] : res;
    const pid = added && added.product_id;
    if (!pid) return;
    const fetchRecs = intent =>
      fetch('/recommendations/products.json?product_id=' + pid + '&limit=4&intent=' + intent)
        .then(r => r.json())
        .then(d => (d.products || []).filter(p => p.available));
    fetchRecs('complementary')
      .then(list => (list.length ? list : fetchRecs('related')))
      .then(list => {
        const picks = list.slice(0, 2);
        if (!picks.length) return;
        const wrap = upsellEl.querySelector('[data-upsell-items]');
        wrap.replaceChildren();
        picks.forEach(p => wrap.appendChild(renderUpsellItem(p)));
        upsellEl.querySelector('[data-upsell-msg]').textContent = successMsg;
        toastEl && toastEl.classList.remove('show');
        clearTimeout(upsellTimer);
        upsellEl.hidden = false;
        requestAnimationFrame(() => upsellEl.classList.add('show'));
        upsellTimer = setTimeout(hideUpsell, 10000);
      })
      .catch(() => {});
  };

  if (upsellEl) {
    upsellEl.querySelector('[data-upsell-close]').addEventListener('click', hideUpsell);
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && upsellEl.classList.contains('show')) hideUpsell();
    });
  }

  document.addEventListener('DOMContentLoaded', () => window.rkUpdateCartCount());
})();
